import { flowService } from "@/service"
import ActionId from "@/action/ActionId"
import Action from "@/action/Action"
import { goto } from "@/util/navigation"
import FinishType from "@/model/flow/FinishType"
import store from "@/store"
import { applicationState, sessionState } from "@/state"

class FinishFlowAction extends Action {

    #finishAction = null
    #stayOnView = false

    constructor(finishAction = FinishType.COMPLETED, stayOnView = false) {
        super(ActionId.FINISH_APPLY)
        this.#finishAction = finishAction
        this.#stayOnView = stayOnView
    }

    async invoke() {
        try {
            switch (this.#finishAction) {
                case FinishType.TIMEOUT:
                    await flowService.finishTimeout()
                    break
                case FinishType.CANCEL:
                    await flowService.finishCanceled()
                    break
                case FinishType.PENDING:
                    await flowService.finishPending()
                    break
                default:
                    await flowService.finishCompleted()
            }
        } catch (e) {
            console.log("Error finishing flow", e)
        } finally {

            function resetSession() {
                applicationState.application = {}
                const previousSession = { ...sessionState.session || {} }
                const newSession = {
                    experienceType: sessionState.session.experienceType,
                    groupId: sessionState.session.groupId,
                }

                store.commit("clearStorage")
                sessionState.session = newSession
                sessionState.previousSession = previousSession
            }

            if (this.#stayOnView) {
                setTimeout(resetSession, 60000)
            } else {
                resetSession()
                await goto({ path: `/finish/${this.#finishAction}` })
            }
        }
    }
}

export default FinishFlowAction
